import React from "react";
import WeAllTeamNewMessage from "@/components/weAllTeam/WeAllTeamNewMessage";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { weAllTeam } from "@/libs/routes";

/**
 * WeAll Team Messages > New message: pick a user, write, send.
 */
const WeAllTeamNewMessagePage = () => <WeAllTeamNewMessage />;

WeAllTeamNewMessagePage.breadCrumbArray = [
  {
    name: breadcrumb_key.weAllTeam.newMessage,
    pathname: weAllTeam.newMessage,
    active: true,
  },
];

export default WeAllTeamNewMessagePage;
